// Build-time public env vars (Vite injects any VITE_* env at build time).
// Copy frontend/datames-customer/.env.example to .env and fill in.
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || '';
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || '';

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  // Don't crash the dev server — just warn loudly in the console.
  // eslint-disable-next-line no-console
  console.warn(
    '[Datames] Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY. ' +
    'Copy .env.example to .env and fill in the values from your Supabase project.'
  );
}

export const supabaseConfig = {
  url: SUPABASE_URL,
  anonKey: SUPABASE_ANON_KEY,
};
